<template>
    <div>
        <v-cookie></v-cookie>
        <div class="place">
            <span>位置：</span>
            <ul class="placeul">
                <li><a href="#">首页</a></li>
                <li>短信</li>
                <li><a href="#">短信历史记录</a></li>
            </ul>
        </div>
    
    <div class="rightinfo">
    <ul class="seachform mt20">
    
        <li style="width: 100%; text-align: center;">
            手机号：{{mobile}} &nbsp;&nbsp;&nbsp;&nbsp;
            <input name="month" type="radio" @click="pageChange('01')" v-model="month" value="01" /><strong>1月</strong>&nbsp;&nbsp;&nbsp;&nbsp;
            <input name="month" type="radio" @click="pageChange('02')" v-model="month" value="02" /><strong>2月</strong>&nbsp;&nbsp;&nbsp;&nbsp;
            <input name="month" type="radio" @click="pageChange('03')" v-model="month" value="03" /><strong>3月</strong>&nbsp;&nbsp;&nbsp;&nbsp;
            <input name="month" type="radio" @click="pageChange('04')" v-model="month" value="04" /><strong>4月</strong>&nbsp;&nbsp;&nbsp;&nbsp;
            <input name="month" type="radio" @click="pageChange('05')" v-model="month" value="05" /><strong>5月</strong>&nbsp;&nbsp;&nbsp;&nbsp;
            <input name="month" type="radio" @click="pageChange('06')" v-model="month" value="06" /><strong>6月</strong>&nbsp;&nbsp;&nbsp;&nbsp;
            <input name="month" type="radio" @click="pageChange('07')" v-model="month" value="07" /><strong>7月</strong>&nbsp;&nbsp;&nbsp;&nbsp;
            <input name="month" type="radio" @click="pageChange('08')" v-model="month" value="08" /><strong>8月</strong>&nbsp;&nbsp;&nbsp;&nbsp;
            <input name="month" type="radio" @click="pageChange('09')" v-model="month" value="09" /><strong>9月</strong>&nbsp;&nbsp;&nbsp;&nbsp;
            <input name="month" type="radio" @click="pageChange('10')" v-model="month" value="10" /><strong>10月</strong>&nbsp;&nbsp;&nbsp;&nbsp;
            <input name="month" type="radio" @click="pageChange('11')" v-model="month" value="11" /><strong>11月</strong>&nbsp;&nbsp;&nbsp;&nbsp;
            <input name="month" type="radio" @click="pageChange('12')" v-model="month" value="12" /><strong>12月</strong>&nbsp;&nbsp;&nbsp;&nbsp;
            <input name="" type="button" class="scbtn" @click="sendsms()" style="width:120px;" value="  点击回复短信  "/>
        </li>

    </ul>
    <table class="tablelist">
        
        <tr v-for="(item,index) in smsMoLogList" bgcolor="#E8F5FE" >
            <!-- <td><input name="" type="checkbox" value="" /></td> -->
            <td style="width:75%"><font color="#79A5F4"><strong>{{item.mobile}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{item.createtime}}</strong></font><br/>{{item.content}}</font></td>
        </tr>  
        <!-- <tr>
            <td style="width:75%">&nbsp;</td>
            <td style="width:15%">&nbsp;</td>    
        </tr> -->
        <tr v-show="isShow">
            <td style="width:75%">您好，没有找到符合条件的记录！</td>
        </tr>
        <tr v-for="(item,index) in smsMtLogList" bgcolor="#FFFFF7">
            <!-- <td><input name="" type="checkbox" value="" /></td> -->
            <td style="width:75%"><font color="#5CDEA7"><strong>{{item.mobile}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{item.createtime}}</strong></font><br/>{{item.content}}</font></td>
        </tr>
    </table>
    
    </div>
    
    
    </div>
</template>
<script>
import cookie from '@/components/cookie.vue'
export default {
    components : {
        'v-cookie' : cookie,
    },
    data(){
        return{
            mobile:'',
            month: '',
            smsMoLogList:[],
            smsMtLogList:[],
            isShow:false,
        }
    },
    mounted(){
        this.mobile = this.$route.query.mobile;
        let date = new Date();
        let month = date.getMonth() + 1;
        if(month < 10){
            this.month = '0' + month;
        }else{
            this.month = month;
        }
        this.pageChange(this.month);
    },
    methods:{
        pageChange(month){
            this.loadingShow = true;
            let that = this;
            let data = {'mobile':this.mobile,'month':month};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/sms/smshistory.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                //console.log(JSON.stringify(res));
                if('0000000' == res.data.code)
                {
                    that.smsMoLogList = res.data.smsMoLogList;
                    that.smsMtLogList = res.data.smsMtLogList;
                    if(that.smsMoLogList.length == 0 && that.smsMtLogList.length == 0){
                        that.isShow = true;
                    }else{
                        that.isShow = false;
                    }
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        sendsms(){
            location.href = "/smssend?mobile="+ this.mobile
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/sms/smshistory.vue